import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import utils from '@utils/util';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PresellOrderDetail.less';

export default class PresellOrderDetail extends OfficialPage {
  state = {
    orderInfo: {},
    orderStatus: {
      '0': '订单待付款',
      '1': '商家待发货',
      '2': '买家待收货',
      '3': '订单待评价',
      '4': '退款审核中',
      '5': '退款中',
      '6': '订单已完成',
      '7': '已退款',
      '8': '卖家待接单'
    },
    presellStatus: {
      '0': '定金待付款',
      '1': '定金待付款',
      '2': '定金支付成功',
      '3': '尾款待付款',
      '4': '商家待发货',
      '5': '订单已取消',
      '6': '退款审核中',
      '7': '商家已退定金',
      '8': '定金退款失败',
      '9': '已关闭',
      '10': '尾款超时未支付',
      '11': '尾款支付成功，请到电商订单查看订单状态',
      '12': '定金超时未支付',
      '13': '退款失败'
    },
    presellIcon: {
      '0': 'goods-undone-payment',
      '1': 'goods-undone-payment',
      '2': 'bargain-pay-success',
      '3': 'goods-undone-payment',
      '4': 'goods-undone-ship',
      '5': 'goods-order-close',
      '6': 'goods-refund',
      '7': 'goods-order-close',
      '8': 'bargain-refund-fail',
      '9': 'goods-order-close',
      '10': 'presell-payment-overtime',
      '11': 'presell-completed',
      '12': 'presell-payment-overtime'
    },
    orderIcon: {
      '0': 'goods-undone-payment',
      '1': 'goods-undone-ship',
      '2': 'goods-undone-receipt',
      '3': 'goods-undone-evaluation',
      '4': 'goods-refund',
      '5': 'goods-refund-doing',
      '6': 'goods-order-complete',
      '7': 'goods-order-close'
    },
    refundStatus: [
      '退款审核中',
      '',
      '',
      '等待买家退货',
      '商家待收货',
      '',
      '已退款'
    ],
    refundIcon: [
      'goods-refund-review',
      '',
      '',
      'goods-refund',
      'goods-undone-receipt',
      '',
      'goods-already-refund'
    ],
    refundReason: [
      '多拍/拍错/不想要',
      '快递延期',
      '未按约定时间发货',
      '快递记录出错',
      '内容与描述不符',
      '其它'
    ],
    formid: [],
    goodsAdditionalInfo: {},
    hasAdditionalInfo: false,
    customFields: [],
    orderId: '',
    isFromTemplateMsg: false,
    originalPrice: '',
    useBalance: '',
    freightAdress: {},
    express_fee: '',
    discount_cut_price: '',
    status: 1,
    isFromBack: false,
    showWriteOffCodeBox: false,
    showEventDialog: false,
    eventType: '',
    hasAlreadyGoods: false,
    final_payment_start_time: '',
    storeStyle: {}
  }
  verifiTimeInterval = ''
  downcountArr = []

  constructor(props) {
    super(props);
    document.title = '订单详情';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.setData({
      orderId: options.detail,
      isFromTemplateMsg: options.from === 'template_msg' ? true : false
    })
    this.franchiseeId = options.franchisee || ''
    this.dataInitial()
  }

  componentDidMount() {
    if (this.data.isFromBack) {
      if (!!this.data.orderInfo.order_id) {
        this.getOrderDetail(this.data.orderInfo.order_id)
      }
    } else {
      this.setData({
        isFromBack: true
      })
    }
  }

  componentWillUnmount() {
    if (this.downcountArr && this.downcountArr.length) {
      this.downcountArr = this.downcountArr.concat().reverse()
      for (let i = 0; i < this.downcountArr.length; i++) {
        this.downcountArr[i] && this.downcountArr[i].clear()
      }
    }
  }

  dataInitial = () => {
    this.getOrderDetail(this.data.orderId)
    this.getLogistics()
    this.getAppECStoreConfig()
    this.setData({
      appName: app.globalData.appTitle,
      appLogo: app.globalData.appLogo
    })
  }
  getOrderDetail = orderId => {
    var that = this
    app.getOrderDetail({
      data: {
        order_id: orderId,
        sub_shop_app_id: this.franchiseeId
      },
      success: function (res) {
        var data = res.data[0],
          form_data = data.form_data,
          hasAdditionalInfo = false,
          additional_info_goods = [],
          additional_goodsid_arr = [],
          address_id = '',
          presell_shopping_cart = form_data.presell_shopping_cart[0],
          is_presell_order = form_data.is_presell_order,
          final_payment_start_time =
            presell_shopping_cart.final_payment_start_time * 1,
          final_payment_end_time =
            presell_shopping_cart.final_payment_end_time * 1,
          server_time = form_data.goods_info[0].server_time,
          is_end = final_payment_end_time < server_time ? true : false,
          status = form_data.status,
          presell_status,
          under_sales
        data.final_payment_name =
          server_time > final_payment_start_time * 1
            ? utils.formatTimeYMD(
              new Date(final_payment_end_time * 1000),
              'M月DD日 hh:mm'
            ) + ' 结束支付尾款'
            : utils.formatTimeYMD(
              new Date(final_payment_start_time * 1000),
              'M月DD日 hh:mm'
            ) + ' 开始支付尾款'
        let usePickType = form_data.ecommerce_info.dispatch_use_pick_up_type
        let intraCityStatus = ''
        if (usePickType == 2) {
          intraCityStatus =
            form_data.ecommerce_info.ecommerce_transport_order &&
            form_data.ecommerce_info.ecommerce_transport_order.status
        }
        switch (is_presell_order) {
          case '1':
            switch (status) {
              case '0':
                presell_status = final_payment_start_time <= server_time ? 0 : 1 // 定金未付款,未到尾款支付时间
                under_sales = true
                break
              case '11':
                presell_status = final_payment_start_time <= server_time ? 3 : 2 //定金已付款，尾款未付款/未到尾款支付时间
                under_sales = true
                break
              case '4':
                // 定金退款审核中
                presell_status = 6
                under_sales = false
                break
              case '7':
                presell_status = form_data.refund_time != '0' ? 7 : 5 // 商家已退定金/订单已取消
                under_sales = false
                break
              case '14':
                presell_status = 5 //商品已取消
                under_sales = false
                break
              case '15':
                presell_status = 8 //退款失败
                under_sales = false
                break
              case '12':
                presell_status = 12
                under_sales = true
                break
            }
            break
          case '2':
            switch (status) {
              case '0':
                presell_status = is_end ? '10' : '3' // 定金已付款，尾款未付款
                under_sales = true
                break
              default:
                presell_status = 4 // 定金已付款，尾款已付款
                under_sales = true
            }
            break
          default:
            switch (status) {
              case '0':
                presell_status = 11 // 尾款阶段
                break
              case '1':
                presell_status = 11 // 尾款阶段
                break
              case '2':
                presell_status = 11 // 尾款阶段
                break
              case '3':
                presell_status = 11 // 尾款阶段
                break
              case '4':
                presell_status = 11 // 尾款阶段
                break
              case '5':
                presell_status = 11 // 尾款阶段
                break
              case '6':
                presell_status = 11 // 尾款阶段
                break
              case '7':
                presell_status = 11 // 尾款阶段
                break
              case '8':
                presell_status = 11 // 尾款阶段
                break
              case '15':
                presell_status = 13 // 退款失败
                break
              default:
                presell_status = 4 // 定金已付款，尾款已付款
                break
            }
            under_sales = true
            break
        }
        if (
          (status == 11 || (status == 7 && is_presell_order == 1)) &&
          server_time > final_payment_end_time * 1
        ) {
          under_sales = true
          presell_status = form_data.refund_time != '0' ? 7 : 10
        }
        if (form_data.additional_info && is_presell_order == 3) {
          for (var i = 0; i < form_data.goods_info.length; i++) {
            var deliveryId = form_data.goods_info[i].delivery_id,
              goodsId = form_data.goods_info[i].goods_id
            if (
              deliveryId &&
              deliveryId != '0' &&
              additional_goodsid_arr.indexOf(goodsId) == -1
            ) {
              additional_info_goods.push(form_data.goods_info[i])
              additional_goodsid_arr.push(goodsId)
              hasAdditionalInfo = true
            }
          }
        }
        let remark = form_data.remark
        form_data.remark = remark ? remark.replace(/\n|\\n/g, '\n') : remark
        for (let i = 0; i < form_data.goods_info.length; i++) {
          if (form_data.goods_info[i].is_seckill == 1) {
            form_data.goods_info[i].downCount = {
              hours: '00',
              minutes: '00',
              seconds: '00'
            }
            if (form_data.goods_info[i].seckill_start_state == 0) {
              form_data.goods_info[i].downcount = app.beforeSeckillDownCount(
                form_data.goods_info[i],
                that,
                'orderInfo.goods_info[' + i + ']'
              )
            } else if (form_data.goods_info[i].seckill_start_state == 1) {
              form_data.goods_info[i].downcount = app.duringSeckillDownCount(
                form_data.goods_info[i],
                that,
                'orderInfo.goods_info[' + i + ']'
              )
            }
            form_data.goods_info[i] &&
              that.downcountArr.push(form_data.goods_info[i].downcount)
          }
        }
        if (form_data.refunded_price && is_presell_order == 3) {
          that.setData({
            hasAlreadyGoods: true
          })
        }
        if (form_data.pick_up_type == 2) {
          let sytime
          let nowTime = new Date().getTime()
          let addTime = form_data.add_time.replace(/\-/g, '/')
          let time = 15 * 60000 - (nowTime - new Date(addTime + '').getTime())
          if (time <= 0) {
            sytime = '0'
          } else {
            sytime = parseInt((time % (1000 * 60 * 60)) / (60 * 1000))
          }
          form_data.cacelOrderCountDownTime = sytime
        }
        final_payment_start_time = utils.formatTimeYMD(
          new Date(final_payment_start_time * 1000),
          'MM月DD日 hh:mm'
        )
        final_payment_end_time = utils.formatTimeYMD(
          new Date(final_payment_end_time * 1000),
          'MM月DD日 hh:mm'
        )
        that.setData({
          orderInfo: form_data,
          order_total_price: that.formatMoney(
            form_data.goods_info[0].price * 1 + form_data.use_balance * 1
          ),
          hasAdditionalInfo: hasAdditionalInfo,
          discount_cut_price: form_data.discount_cut_price,
          useBalance: form_data['use_balance'],
          express_fee: res.data[0]['express_fee'],
          intraCityStatus: intraCityStatus || '',
          usePickType: usePickType,
          presell_status: presell_status,
          under_sales: under_sales,
          is_presell_order: is_presell_order,
          final_payment_start_time: final_payment_start_time,
          final_payment_end_time: final_payment_end_time
        })
        app.setPreviewGoodsInfo(additional_info_goods)
        app.setGoodsAdditionalInfo(form_data.additional_info || {})
        that.getRefundConfigByPickUpType(form_data.pick_up_type)
      }
    })
  }
  orderDelete = e => {
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/HideOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function (res) {
        app.turnBack()
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  formatMoney = (number, places, symbol, thousand, decimal) => {
    number = number || 0
    places = !isNaN((places = Math.abs(places))) ? places : 2
    symbol = symbol !== undefined ? symbol : ''
    thousand = thousand || ','
    decimal = decimal || '.'
    var negative = number < 0 ? '-' : '',
      i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
      j = (j = i.length) > 3 ? j % 3 : 0
    return (
      symbol +
      negative +
      (j ? i.substr(0, j) + thousand : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, '¥1' + thousand) +
      (places
        ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
        : '')
    )
  }
  cancelOrder = e => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/cancelOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId || ''
      },
      success: function (res) {
        var data = {}
        data['presell_status'] = 5
        that.setData(data)
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  payOrder = e => {
    var address_info = this.data.orderInfo.address_info,
      that = this,
      orderInfo = this.data.orderInfo,
      goodsInfo = orderInfo.goods_info[0],
      paymentOrder = orderInfo._presell_final_payment_order,
      presell_shopping_cart = orderInfo.presell_shopping_cart[0],
      orderId = orderInfo.order_id
    if (
      this.data.presell_status == 3 &&
      presell_shopping_cart.is_presell_order == 1 &&
      !paymentOrder
    ) {
      var that = this,
        franchiseeId = that.data.franchiseeId,
        param = {
          goods_id: goodsInfo.goods_id,
          activity_id: goodsInfo.presell_activity_id || '',
          model_id: goodsInfo.modelId || '',
          nums: goodsInfo.num,
          sub_shop_app_id: franchiseeId || '',
          final_payment_start_time: that.data.final_payment_start_time || '',
          address_id: '',
          type: '1',
          models_text:
            goodsInfo.model_value == null ? '' : goodsInfo.model_value,
          models_stock: presell_shopping_cart.presell_stock_left,
          bargain_order_id: orderInfo.order_id,
          presell_status: that.data.presell_status,
          limit_buy: presell_shopping_cart.buy_limit_num
        },
        pagePath =
          '/presell/pages/previewPresellOrder/previewPresellOrder?param=' +
          encodeURIComponent(JSON.stringify(param))
      that.saveUserFormId(function () {
        app.turnToPage(pagePath, 0)
      })
      return
    }
    that.saveUserFormId()
    if (this.data.orderInfo.total_price == 0 && !paymentOrder) {
      app.sendRequest({
        url: '/index.php?r=AppPreSell/AddOrder',
        method: 'Post',
        data: {
          sub_shop_app_id: that.data.franchiseeId,
          is_balance: that.data.useBalance ? 1 : 0,
          address_id: orderInfo.address_id,
          pick_up_type: 1,
          presell_shopping_cart: [
            {
              goods_id: goodsInfo.goods_id,
              num: goodsInfo.num,
              model_id: goodsInfo.model_id
            }
          ],
          bargain_order_id: orderId
        },
        success: function (res) {
          setTimeout(function () {
            app.showToast({
              title: '支付成功',
              icon: 'success',
              success: function () {
                that.paySuccessCallback()
              }
            })
          })
        }
      })
      return
    }
    orderId = paymentOrder ? paymentOrder.order_id : orderInfo.order_id
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.goodsType = that.data.orderInfo.goods_type
    //     param.success = function () {
    //       that.paySuccessCallback()
    //     }
    //     app.wxPay(param)
    //   }
    // })
    var paySuccessUrl = () => {
      let orderId = this.data.orderId
      let franchiseeId = this.franchiseeId
      return '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' +
        orderId +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    }
    app.goPay({
      orderId: orderId,
      successUrl: paySuccessUrl()
    })
  }
  wxPay = param => {
    var that = this
    Taro.requestPayment({
      timeStamp: param.timeStamp,
      nonceStr: param.nonceStr,
      package: param.package,
      signType: param.signType,
      paySign: param.paySign,
      success: function (res) {
        app.wxPaySuccess(param)
        param.success()
      },
      fail: function (res) {
        if (res.errMsg === 'requestPayment:fail cancel') {
          app.showModal({
            content: '支付已取消',
            complete: param.fail
          })
          return
        }
        app.showModal({
          content: '支付失败',
          complete: param.fail
        })
        app.wxPayFail(param, res.errMsg)
      }
    })
  }
  applyDrawback = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/previewGoodsRefund/previewGoodsRefund?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    that.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  remindCustomer = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppPreSell/RemindCustomer',
      data: {
        order_id: that.data.orderInfo.order_id
      },
      success: function () {
        var data = {}
        data['orderInfo.status'] = 7
        data['presell_status'] = 8
        that.setData(data)
      }
    })
  }
  editorRefund = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsRefundPage/goodsRefundPage?type=editor&orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    that.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  receiveDrawback = () => {
    var orderId = this.data.orderInfo.order_id,
      that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        var data = {}
        data['orderInfo.status'] = 7
        that.setData(data)
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  checkLogistics = () => {
    let orderId = this.data.orderId
    let ecommerce_info = this.data.orderInfo.ecommerce_info
    let usePickType = this.data.usePickType
    if (usePickType == 2) {
      let intraCityData = ecommerce_info.intra_city_data
      let type = (intraCityData && intraCityData.deliver_type) || ''
      let arriveTime =
        (intraCityData && intraCityData.intra_city_appointment_arrive_time) ||
        ''
      this.saveUserFormId(function () {
        app.turnToPage(
          '/eCommerce/pages/sameJourneyLogistic/sameJourneyLogistic?orderId=' +
          orderId +
          '&type=' +
          type +
          '&arriveTime=' +
          arriveTime +
          '&franchiseeId=' +
          this.franchiseeId,
          0
        )
      })
    } else {
      this.saveUserFormId(function () {
        app.turnToPage(
          '/eCommerce/pages/logisticsPage/logisticsPage?detail=' +
          orderId +
          '&franchiseeId=' +
          this.franchiseeId,
          0
        )
      })
    }
  }
  sureReceipt = () => {
    var orderId = this.data.orderId,
      that = this,
      addTime = Date.now()
    app.sendRequest({
      url: '/index.php?r=AppShop/comfirmOrder',
      data: {
        order_id: orderId,
        sub_shop_app_id: that.franchiseeId
      },
      success: function (res) {
        that.saveUserFormId(function () {
          app.turnToPage(
            '/eCommerce/pages/transactionSuccess/transactionSuccess?pageFrom=transation&orderId=' +
            orderId +
            '&franchiseeId=' +
            that.franchiseeId,
            0
          )
        })
        app.sendRequest({
          hideLoading: true,
          url: '/index.php?r=appShop/getIntegralLog',
          data: {
            add_time: addTime
          },
          success: function (res) {
            if (res.status == 0) {
              res.data &&
                that.setData({
                  rewardPointObj: {
                    showModal: true,
                    count: res.data,
                    callback: ''
                  }
                })
            }
          }
        })
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  makeComment = () => {
    var franchiseeId = this.franchiseeId,
      pagePath =
        '/eCommerce/pages/makeComment/makeComment?detail=' +
        this.data.orderInfo.order_id +
        (franchiseeId ? '&franchisee=' + franchiseeId : '')
    this.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  goToHomepage = () => {
    var router = app.getHomepageRouter()
    this.saveUserFormId(function () {
      app.turnToPage('/pages/' + router + '/' + router, 1)
    })
  }
  getFreigtAdress = () => {
    var that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/getAppShopLocationInfo',
      data: {
        app_id: app.getAppId(),
        sub_app_id: that.franchiseeId
      },
      success: function (res) {
        that.setData({
          freightAdress: res.data
        })
      }
    })
  }
  seeAdditionalInfo = () => {
    this.saveUserFormId(function () {
      app.turnToPage(
        '/eCommerce/pages/goodsAdditionalInfo/goodsAdditionalInfo?from=goodsOrderDetail',
        0
      )
    })
  }
  paySuccessCallback = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/presell/pages/presellPaySuccess/presellPaySuccess?detail=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    if (!franchiseeId) {
      app.sendRequest({
        url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
        data: {
          order_id: orderId,
          sub_app_id: franchiseeId
        },
        success: function (res) {
          if (res.valid == 0) {
            pagePath += '&collectBenefit=1'
          }
          that.saveUserFormId(function () {
            app.turnToPage(pagePath, 0)
          })
        }
      })
    } else {
      that.saveUserFormId(function () {
        app.turnToPage(pagePath, 0)
      })
    }
  }
  copyOrderId = () => {
    let that = this
    app.setClipboardData({
      data: that.data.orderId,
      success: function (res) {
        app.showToast({
          title: '复制成功',
          icon: 'success'
        })
      }
    })
  }
  showGoodsDetail = e => {
    var orderId = e.currentTarget.dataset.orderid
    app.turnToPage(
      '/eCommerce/pages/goodsOrderDetail/goodsOrderDetail?detail=' +
      this.data.orderInfo.order_id
    )
  }
  getWriteOffCodeBox = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/GetOrderVerifyCode',
      data: {
        sub_shop_app_id: franchiseeId,
        order_id: orderId
      },
      success: that.setVerificationCodeData
    })
  }
  setVerificationCodeData = res => {
    let that = this
    that.setData({
      codeImgUrl: res.data.qrcode_url,
      codeNum: res.data.code,
      codeStatus: res.data.status,
      showWriteOffCodeBox: true
    })
    that.connectSocket()
  }
  connectSocket = () => {
    var that = this
    Taro.connectSocket({
      url: 'wss://ceshi.zhichiwangluo.com', //线下test
      header: {
        'content-type': 'application/json'
      },
      method: 'GET'
    })
    Taro.onSocketOpen(function (res) {
      let data = {
        action: 'mark_client',
        user_token: app.globalData.userInfo.user_token,
        scenario_name: 'app_order_verify',
        session_key: app.globalData.sessionKey
      }
      Taro.sendSocketMessage({
        data: JSON.stringify(data)
      })
      that.verifiTimeInterval = setInterval(function () {
        let data = {
          action: 'heartbeat',
          user_token: app.globalData.userInfo.user_token,
          scenario_name: 'app_order_verify',
          session_key: app.globalData.sessionKey
        }
        Taro.sendSocketMessage({
          data: JSON.stringify(data)
        })
      }, 30000)
    })
    Taro.onSocketMessage(function (res) {
      let data = JSON.parse(res.data)
      if (data.action == 'push_to_client') {
        let msg = JSON.parse(data.msg)
        if (msg.type == 'app_order_verify' && msg.status == 0) {
          that.setData({
            codeStatus: 1
          })
          clearInterval(that.verifiTimeInterval)
          Taro.closeSocket()
        }
      }
    })
  }
  hideWriteOffCodeBox = () => {
    var that = this
    this.setData({
      showWriteOffCodeBox: false
    })
    clearInterval(that.verifiTimeInterval)
    Taro.closeSocket()
  }
  hideEventDialog = () => {
    this.setData({
      showEventDialog: false
    })
  }
  showEventDialog = event => {
    this.setData({
      eventType: event.currentTarget.dataset.type,
      showEventDialog: true
    })
  }
  goOrderProgress = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsOrderProgress/goodsOrderProgress?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    that.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  returnInfor = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let pagePath =
      '/eCommerce/pages/goodsReturnInfor/goodsReturnInfor?orderId=' +
      orderId +
      (franchiseeId ? '&franchisee=' + franchiseeId : '')
    that.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  cancelRefund = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.showModal({
      content: '确认取消退款吗？',
      showCancel: true,
      confirm: function () {
        app.sendRequest({
          url: '/index.php?r=appShop/cancelRefund',
          data: {
            order_id: orderId,
            sub_shop_app_id: franchiseeId,
            _app_id: 'GumaC311tx'
          },
          success: function () {
            that.getOrderDetail(orderId)
          }
        })
      }
    })
  }
  getAppECStoreConfig = () => {
    app.getAppECStoreConfig(res => {
      this.setData({
        storeStyle: res.color_config
      })
    }, this.franchiseeId)
  }
  deliveryDrawback = () => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    app.sendRequest({
      url: '/index.php?r=AppShop/applyRefund',
      data: {
        order_id: orderId,
        sub_shop_app_id: franchiseeId
      },
      success: function (res) {
        that.getOrderDetail(orderId)
      },
      complete: function () {
        that.setData({
          showEventDialog: false
        })
      }
    })
  }
  goAlreadyGoodsPage = () => {
    let that = this
    let pagePath = '/eCommerce/pages/goodsAlreadyRefunded/goodsAlreadyRefunded'
    that.saveUserFormId(function () {
      app.turnToPage(pagePath, 0)
    })
  }
  getLogistics = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppShop/expressFlow',
      data: {
        order_id: that.data.orderId
      },
      success: function (res) {
        if (!res.data) {
          return
        }
        if (res.data.is_custom) {
          that.setData({
            logisticsCustom: res.data.is_custom
          })
        } else {
          that.setData({
            info: res.data,
            logistics: res.data.Traces
          })
        }
      }
    })
  }
  formSubmit_collect = e => {
    let formid = this.data.formid
    formid.push(e.target.formId)
  }
  saveUserFormId = callback => {
    app.showLoading({
      title: '加载中'
    })
    var _this = this
    app.sendRequest({
      url: '/index.php?r=api/AppMsgTpl/saveUserFormId',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchiseeId || '',
        form_id: _this.data.formid || []
      },
      complete: function () {
        app.hideLoading()
        callback && callback()
        _this.setData({
          formid: []
        })
      }
    })
  }
  toGoodsAfterSaleDetail = event => {
    let that = this
    let orderId = this.data.orderId
    let franchiseeId = this.franchiseeId
    let applyId = this.data.orderInfo.refund_apply.id
    let router =
      '/eCommerce/pages/goodsAfterSaleDetail/goodsAfterSaleDetail?applyId=' +
      applyId +
      '&detail=' +
      orderId +
      '&franchisee=' +
      franchiseeId
    that.saveUserFormId(function () {
      app.turnToPage(router)
    })
  }
  goDeliveryNavigation = () => {
    Taro.openLocation({
      latitude: Number(this.data.orderInfo.self_delivery_info.latitude),
      longitude: Number(this.data.orderInfo.self_delivery_info.longitude),
      name: this.data.orderInfo.self_delivery_info.address
    })
  }
  sameJournyLogistic = () => {
    let that = this
    var orderId = this.data.orderId
    that.saveUserFormId(function () {
      app.turnToPage(
        '/eCommerce/pages/sameJournyLogistic/sameJournyLogistic?detail=' +
        orderId,
        0
      )
    })
  }
  getRefundConfigByPickUpType = type => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppEcommerce/getRefundConfigByPickUpType',
      data: {
        pick_up_type: type
      },
      success: function (res) {
        if (res.data && res.data.config_data) {
          let data = res.data.config_data
          that.setData({
            refundAdress: data.address || '',
            isFullRefund: data.is_full_refund
          })
        }
      }
    })
  }

  render() {
    const {
      showGetUserInfo,
      rewardPointObj,
      presell_status,
      isFromTemplateMsg,
      storeStyle,
      presellIcon,
      presellStatus,
      is_presell_order,
      orderInfo,
      orderIcon,
      orderStatus,
      refundIcon,
      refundStatus,
      refundAdress,
      logistics,
      logisticsCustom,
      usePickType,
      appLogo,
      appName,
      useBalance,
      final_payment_start_time,
      final_payment_end_time,
      discount_cut_price,
      express_fee,
      under_sales,
      hasAdditionalInfo,
      hasAlreadyGoods,
      prsell_status,
      intraCityStatus,
      isFullRefund,
      codeImgUrl,
      codeStatus,
      codeNum,
      showWriteOffCodeBox,
      eventType,
      showEventDialog
    } = this.state

    return (
      <div className="official-page presell-order-detail">
        <TopNav title="订单详情"/>
        <React.Fragment>
          <div
            className="order-contain"
            style={convertLineStyleData(
              'height:' +
              (presell_status == 2 || presell_status == 10 || presell_status == 12
                ? '100%'
                : 'calc(100% - 88rpx)') +
              ';'
            )}
          >
            {isFromTemplateMsg && (
              <div
                className="orderDetail-goto-homepage"
                onClick={this.goToHomepage}
              >
                返回首页
              </div>
            )}
            <div
              className="seller-shipped"
              style={convertLineStyleData('background:' + storeStyle.theme)}
            >
              {is_presell_order == 1 || is_presell_order == 3 ? (
                <div>
                  <span
                    className={
                      'order-icon ico-moon icon-' + presellIcon[presell_status]
                    }
                  ></span>
                  <span>{presellStatus[presell_status]}</span>
                </div>
              ) : orderInfo.status != 4 ? (
                <div>
                  <span
                    className={
                      'order-icon ico-moon icon-' + orderIcon[orderInfo.status]
                    }
                  ></span>
                  <span>
                    {orderInfo.pick_up_type != 1 && orderInfo.status == 8
                      ? '商家待接单'
                      : orderStatus[orderInfo.status]}
                  </span>
                </div>
              ) : (
                    <div>
                      <span
                        className={
                          'order-icon ico-moon icon-' +
                          refundIcon[orderInfo.refund_apply.status]
                        }
                      ></span>
                      <span>
                        {orderInfo.is_pay_on_delivery == 1
                          ? '审核中'
                          : refundStatus[orderInfo.refund_apply.status]}
                      </span>
                    </div>
                  )}
            </div>
            {orderInfo.status == 0 &&
              orderInfo.expire &&
              presell_status != 5 &&
              is_presell_order != 3 && (
                <div className="order-prompt">
                  请尽快完成付款，还剩
                  <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                    {orderInfo.has_seckill == 1
                      ? orderInfo.close_order_time + '分'
                      : orderInfo.expire}
                  </span>
                  (超时按<span style={convertLineStyleData('color:' + storeStyle.theme)}>取消订单</span>
                  处理)
                </div>
              )}
            {orderInfo.status == 1 && orderInfo.expire && (
              <div className="order-prompt">付款成功，请耐心等待商家发货</div>
            )}
            {orderInfo.status == 2 && (
              <div className="order-prompt">
                商家已发货，距自动收货还剩
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {orderInfo.has_seckill == 1
                    ? orderInfo.close_order_time + '分'
                    : orderInfo.expire}
                </span>
              </div>
            )}
            {orderInfo.status == 4 && orderInfo.refund_apply.status == 0 && (
              <div className="order-prompt">
                你已成功发起退款申请，请耐心等待商家处理，还剩
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {orderInfo.refund_apply.expire}
                </span>
                （超时按
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {orderInfo.is_pay_on_delivery == 1
                    ? '拒绝取消订单'
                    : '拒绝退款'}
                </span>
                处理）
              </div>
            )}
            {orderInfo.status == 4 && orderInfo.refund_apply.status == 3 && (
              <div className="order-prompt">
                商家已同意退货退款申请，请及时退货，还剩
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>
                  {orderInfo.refund_apply.expire}
                </span>
                （超时按
                <span style={convertLineStyleData('color:' + storeStyle.theme)}>买家撤销退货</span>
                处理）
              </div>
            )}
            {orderInfo.status == 4 && orderInfo.refund_apply.status == 4 && (
              <div className="order-prompt">
                请耐心等待商家收货，收货完成后将会进行退款
              </div>
            )}
            {(presell_status == 7 ||
              presell_status == 8 ||
              presell_status == 9 ||
              presell_status == 6) &&
              orderInfo.refund_apply.refund_remark && (
                <div className="order-prompt">
                  {'退款备注：' + (orderInfo.refund_apply.refund_remark || '')}
                </div>
              )}
            {orderInfo.pick_up_type == 2 && orderInfo.status == 8 && (
              <div className="order-prompt">
                {orderInfo.cacelOrderCountDownTime + '分钟未接单，订单将自动取消'}
              </div>
            )}
            {orderInfo.status == 4 &&
              orderInfo.refund_apply.refund_type == 2 &&
              orderInfo.is_pay_on_delivery != 1 && (
                <React.Fragment>
                  <div className="refund-address-box">
                    <div className="refund-address-title">
                      <span>退货地址</span>
                      <span className="pull-right">
                        {refundAdress.brand_name + ' ' + refundAdress.phone}
                      </span>
                    </div>
                    <div className="pull-right refund-address">
                      {refundAdress.region_info[2].name +
                        refundAdress.region_info[1].name +
                        refundAdress.region_info[0].name +
                        refundAdress.detail_address}
                    </div>
                  </div>
                </React.Fragment>
              )}
            {(orderInfo.status == 2 ||
              orderInfo.status == 3 ||
              orderInfo.status == 5) &&
              usePickType == 1 && (
                <div onClick={this.checkLogistics}>
                  <div className="goods-logistics">
                    <span className="ico-moon icon-goods-logistics"></span>
                    {logistics.length ? (
                      <div className="goods-logistics-info">
                        <div
                          className="goods-logistics-title"
                          style={convertLineStyleData('color:' + storeStyle.theme)}
                        >
                          {logistics[0].AcceptStation}
                        </div>
                        <div className="goods-logistics-time">
                          {logistics[0].AcceptTime}
                        </div>
                      </div>
                    ) : (
                        <div className="goods-logistics-info">
                          {logisticsCustom == 1 ? '商家自主发货' : '暂无物流信息'}
                        </div>
                      )}
                    <span
                      style={convertLineStyleData('display: inline-block;vertical-align: middle;')}
                      className="colord2d2 ico-moon icon-rightarrow"
                    ></span>
                  </div>
                </div>
              )}
            {is_presell_order == 1 || is_presell_order == 3 ? (
              <React.Fragment>
                {presell_status != 7 && (
                  <div className="buyer-information self-delivery-info">
                    <span className="ico-moon icon-goods-location"></span>
                    {orderInfo.pick_up_type == 1 && (
                      <React.Fragment>
                        <div className="buyer-box">
                          <div className="buyer-name-box">
                            <span
                              className="cash-delivery shipping-type"
                              style={convertLineStyleData('background:' + storeStyle.theme)}
                            >
                              快递
                            </span>
                            {orderInfo.is_pay_on_delivery == 1 && (
                              <span
                                className="cash-delivery"
                                style={convertLineStyleData('background:' + storeStyle.theme)}
                              >
                                到付
                              </span>
                            )}
                            <span className="buyer-name">
                              {orderInfo.address_info.name}
                            </span>
                            <span>{orderInfo.address_info.contact}</span>
                          </div>
                          <div className="buyer-address">
                            {orderInfo.address_info.province.text +
                              orderInfo.address_info.city.text +
                              orderInfo.address_info.district.text +
                              orderInfo.address_info.detailAddress}
                          </div>
                        </div>
                      </React.Fragment>
                    )}
                    {orderInfo.pick_up_type == 2 ? (
                      <React.Fragment>
                        <div className="buyer-box">
                          <div className="buyer-name-box">
                            <span
                              className="cash-delivery shipping-type"
                              style={convertLineStyleData('background:' + storeStyle.theme)}
                            >
                              同城
                            </span>
                            {orderInfo.is_pay_on_delivery == 1 && (
                              <span
                                className="cash-delivery"
                                style={convertLineStyleData('background:' + storeStyle.theme)}
                              >
                                到付
                              </span>
                            )}
                            <span className="buyer-name">
                              {orderInfo.address_info.name}
                            </span>
                            <span>{orderInfo.address_info.contact}</span>
                          </div>
                          <div className="buyer-address">
                            {orderInfo.address_info.province.text +
                              orderInfo.address_info.city.text +
                              orderInfo.address_info.district.text +
                              orderInfo.address_info.detailAddress}
                          </div>
                        </div>
                      </React.Fragment>
                    ) : (
                        orderInfo.pick_up_type == 3 && (
                          <React.Fragment>
                            <div className="buyer-box">
                              <div className="buyer-name-box">
                                <span
                                  className="cash-delivery shipping-type"
                                  style={convertLineStyleData('background:' + storeStyle.theme)}
                                >
                                  自提
                              </span>
                                {orderInfo.is_pay_on_delivery == 1 && (
                                  <span
                                    className="cash-delivery"
                                    style={convertLineStyleData('background:' + storeStyle.theme)}
                                  >
                                    到付
                                </span>
                                )}
                                <span className="buyer-name">
                                  {orderInfo.self_delivery_info.contact_name}
                                </span>
                                <span>
                                  {orderInfo.self_delivery_info.contact_phone}
                                </span>
                              </div>
                              <div className="buyer-address">
                                {orderInfo.self_delivery_info.address}
                              </div>
                            </div>
                            <div
                              className="delivery-navigation"
                              style={convertLineStyleData('color:' + storeStyle.theme)}
                              onClick={this.goDeliveryNavigation}
                            >
                              导航
                          </div>
                          </React.Fragment>
                        )
                      )}
                  </div>
                )}
                {presell_status != 7 && presell_status != 6 ? (
                  <div className="app-box">
                    <div>
                      <img className="app-logo" src={appLogo} />
                      <span className="app-name">{appName}</span>
                      <div className="contact-service pull-right">
                        <span>联系客服</span>
                        <span className="ico-moon icon-goods-customer-service"></span>
                        <button></button>
                      </div>
                    </div>
                  </div>
                ) : (
                    <div className="refund-msg">退货信息</div>
                  )}
                {orderInfo.goods_info.map((goods, goodsIndex) => {
                  return (
                    <React.Fragment key={goodsIndex}>
                      <div className="goods-detail-box">
                        <img src={goods.cover} />
                        <div>
                          <div className="goods-name">
                            <span className="is-seckill">预售</span>
                            {goods.goods_name}
                          </div>
                          <div className="goods-rules">
                            {goods.model_value == null ? '' : goods.model_value}
                          </div>
                          <div className="goods-price">
                            {!goods.use_integral || goods.use_integral == 0 ? (
                              <React.Fragment>
                                <span
                                  className="colorff7"
                                  style={convertLineStyleData('color:' + storeStyle.theme)}
                                >
                                  {'¥' + goods.price}
                                </span>
                              </React.Fragment>
                            ) : (
                                <React.Fragment>
                                  {goods.price != '0.00' && (
                                    <span
                                      className="colorff7"
                                      style={convertLineStyleData('color:' + storeStyle.theme)}
                                    >
                                      {'¥' + goods.price}
                                    </span>
                                  )}
                                  {goods.max_can_use_integral &&
                                    goods.max_can_use_integral != '0' &&
                                    goods.max_can_use_integral != 0 &&
                                    goods.price != '0.00' && (
                                      <span
                                        className="colorff7"
                                        style={convertLineStyleData('color:' + storeStyle.theme)}
                                      >
                                        +
                                    </span>
                                    )}
                                  {goods.max_can_use_integral &&
                                    goods.max_can_use_integral != '0' &&
                                    goods.max_can_use_integral != 0 && (
                                      <span
                                        className="colorff7"
                                        style={convertLineStyleData('color:' + storeStyle.theme)}
                                      >
                                        {goods.max_can_use_integral + '积分'}
                                      </span>
                                    )}
                                </React.Fragment>
                              )}
                            <span className="pull-right">{'x ' + goods.num}</span>
                          </div>
                        </div>
                      </div>
                    </React.Fragment>
                  )
                })}
                {orderInfo.status == 4 &&
                  presell_status != 6 &&
                  orderInfo.refund_apply.id && (
                    <div className="refunding-btn-box">
                      <span
                        className="refunding-btn"
                        onClick={this.toGoodsAfterSaleDetail}
                      >
                        退款中
                      </span>
                    </div>
                  )}
                <div style={convertLineStyleData('padding:0 30rpx;')}>
                  {under_sales ? (
                    <React.Fragment>
                      <div className="section-presell section-one">
                        {presell_status == 0 || presell_status == 1 ? (
                          <React.Fragment>
                            <div>
                              <div className="section-tips">
                                <div>
                                  <span></span>
                                  <span></span>
                                </div>
                                <div>阶段1：等待买家付款</div>
                              </div>
                              <div className="detail-msg">
                                <div className="presell-amount">
                                  <span>商品定金</span>
                                  <span className="pull-right">
                                    {'¥' + orderInfo.total_bargain}
                                  </span>
                                </div>
                                {presell_status != 0 && presell_status != 1 && (
                                  <React.Fragment>
                                    {orderInfo.bargain_use_balance &&
                                      orderInfo.bargain_use_balance > 0 ? (
                                        <div className="stored-value-deduction">
                                          <span>储值抵扣</span>
                                          <span className="pull-right">
                                            {'- ¥ ' + orderInfo.bargain_use_balance}
                                          </span>
                                        </div>
                                      ) : (
                                        is_presell_order == 1 &&
                                        useBalance && (
                                          <div className="stored-value-deduction">
                                            <span>储值抵扣</span>
                                            <span className="pull-right">
                                              {'- ¥ ' + useBalance}
                                            </span>
                                          </div>
                                        )
                                      )}
                                  </React.Fragment>
                                )}
                              </div>
                            </div>
                            <div className="actual-presell-amount">
                              <span>定金需付款</span>
                              <span className="pull-right">
                                {'¥' + orderInfo.total_bargain}
                              </span>
                            </div>
                          </React.Fragment>
                        ) : (
                            presell_status != 0 &&
                            presell_status != 1 && (
                              <React.Fragment>
                                <div>
                                  <div className="section-tips">
                                    <div>
                                      <span></span>
                                      <span></span>
                                    </div>
                                    <div>
                                      {presell_status == 5
                                        ? '阶段1：已取消'
                                        : presell_status == 12
                                          ? '阶段1：未完成'
                                          : '阶段1：已完成'}
                                    </div>
                                  </div>
                                  <div className="detail-msg">
                                    <div className="presell-amount">
                                      <span>商品定金</span>
                                      <span className="pull-right">
                                        {'¥' + orderInfo.total_bargain}
                                      </span>
                                    </div>
                                    {orderInfo.bargain_use_balance &&
                                      orderInfo.bargain_use_balance > 0 ? (
                                        <div className="stored-value-deduction">
                                          <span>储值抵扣</span>
                                          <span className="pull-right">
                                            {'- ¥ ' + orderInfo.bargain_use_balance}
                                          </span>
                                        </div>
                                      ) : (
                                        is_presell_order == 1 &&
                                        useBalance && (
                                          <div className="stored-value-deduction">
                                            <span>储值抵扣</span>
                                            <span className="pull-right">
                                              {'- ¥ ' + useBalance}
                                            </span>
                                          </div>
                                        )
                                      )}
                                  </div>
                                </div>
                                {presell_status != 5 && (
                                  <div className="actual-presell-amount">
                                    <span>
                                      {presell_status == 5
                                        ? '定金未支付'
                                        : presell_status == 12
                                          ? '定金未支付'
                                          : '定金实付款'}
                                    </span>
                                    <span className="pull-right">
                                      {'¥' + orderInfo.total_bargain}
                                    </span>
                                  </div>
                                )}
                              </React.Fragment>
                            )
                          )}
                      </div>
                      <div className="section-presell section-two">
                        <div>
                          {presell_status == 2 ? (
                            <React.Fragment>
                              <div className="section-tips">
                                <div>
                                  <span></span>
                                  <span></span>
                                </div>
                                <div>阶段2：未开始</div>
                              </div>
                              <div className="detail-msg">
                                <div className="surplus-tips">
                                  <span>
                                    {final_payment_start_time + ' 开始支付尾款'}
                                  </span>
                                  <span className="pull-right">
                                    {'¥ ' + orderInfo.total_final_payment}
                                  </span>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : presell_status == 1 ||
                            presell_status == 3 ||
                            presell_status == 0 ? (
                                <React.Fragment>
                                  <div className="section-tips">
                                    <div>
                                      <span></span>
                                      <span></span>
                                    </div>
                                    <div>阶段2：等待买家付款</div>
                                  </div>
                                  <div className="detail-msg">
                                    <div className="final_payment_end_time">
                                      <span>
                                        {final_payment_end_time + ' 结束支付尾款'}
                                      </span>
                                    </div>
                                    <div className="goods-amount">
                                      <span>商品尾款</span>
                                      <span className="pull-right">
                                        {'¥ ' + orderInfo.total_final_payment}
                                      </span>
                                    </div>
                                  </div>
                                </React.Fragment>
                              ) : presell_status == 4 || is_presell_order == 3 ? (
                                <React.Fragment>
                                  <div className="section-tips">
                                    <div>
                                      <span></span>
                                      <span></span>
                                    </div>
                                    <div>阶段2：已完成</div>
                                  </div>
                                  <div className="detail-msg">
                                    <div className="goods-amount">
                                      <span>商品尾款</span>
                                      <span className="pull-right">
                                        {'¥ ' + orderInfo.total_final_payment}
                                      </span>
                                    </div>
                                    {orderInfo.has_seckill == 1 && (
                                      <div className="spike-offer">
                                        <span>活动优惠</span>
                                        <span className="pull-right">
                                          {'秒杀  - ¥ ' + orderInfo.seckill_cut_price}
                                        </span>
                                      </div>
                                    )}
                                    {orderInfo.selected_benefit_info && (
                                      <div className="promotion-method">
                                        <div style={convertLineStyleData('overflow:hidden;')}>
                                          <span>优惠抵扣</span>
                                          <span
                                            className="pull-right promotion-method-title"
                                            style={convertLineStyleData('color:#999;')}
                                          >
                                            {orderInfo.selected_benefit_info.title ||
                                              '无'}
                                          </span>
                                        </div>
                                        <div
                                          className="pull-right"
                                          style={convertLineStyleData('margin-top:20rpx;')}
                                        >
                                          {'- ¥ ' + discount_cut_price}
                                        </div>
                                      </div>
                                    )}
                                    {/*  <view class="total-order-price">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <text>订单总价</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            <text class="pull-right">¥ {{ order_total_price }}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          </view>  */}
                                    {useBalance > 0 && (
                                      <div className="stored-value-deduction">
                                        <span>储值抵扣</span>
                                        <span className="pull-right">
                                          {'- ¥ ' + orderInfo.final_use_balance}
                                        </span>
                                      </div>
                                    )}
                                  </div>
                                </React.Fragment>
                              ) : presell_status == 5 ? (
                                <React.Fragment>
                                  <div className="section-tips">
                                    <div>
                                      <span></span>
                                      <span></span>
                                    </div>
                                    <div>阶段2：已取消</div>
                                  </div>
                                  <div className="detail-msg">
                                    <div className="goods-amount">
                                      <span>商品尾款</span>
                                      <span className="pull-right">
                                        {'¥ ' + orderInfo.total_final_payment}
                                      </span>
                                    </div>
                                  </div>
                                </React.Fragment>
                              ) : (
                                    (presell_status == 10 || presell_status == 12) && (
                                      <React.Fragment>
                                        <div className="section-tips">
                                          <div>
                                            <span></span>
                                            <span></span>
                                          </div>
                                          <div>阶段2：未完成</div>
                                        </div>
                                        <div className="detail-msg">
                                          <div className="surplus-tips">
                                            <span>
                                              {final_payment_end_time + ' 结束支付尾款'}
                                            </span>
                                            <span className="pull-right">
                                              {'¥ ' +
                                                orderInfo.presell_shopping_cart[0]
                                                  .final_payment}
                                            </span>
                                          </div>
                                        </div>
                                      </React.Fragment>
                                    )
                                  )}
                        </div>
                        {!(
                          (orderInfo.status == 7 && is_presell_order != 3) ||
                          presell_status == 0 ||
                          presell_status == 1 ||
                          presell_status == 5
                        ) && (
                            <div className="actual-payment">
                              {presell_status == 3 || presell_status == 2 ? (
                                <React.Fragment>
                                  <span>尾款待付款</span>
                                  <span className="pull-right" style={convertLineStyleData('color:#333;')}>
                                    {'¥ ' + orderInfo.total_final_payment}
                                  </span>
                                </React.Fragment>
                              ) : presell_status == 10 || presell_status == 12 ? (
                                <React.Fragment>
                                  <span>尾款未支付</span>
                                  <span className="pull-right" style={convertLineStyleData('color:#333;')}>
                                    {'¥ ' + orderInfo.total_final_payment}
                                  </span>
                                </React.Fragment>
                              ) : (
                                    <React.Fragment>
                                      <span>尾款实付款</span>
                                      <span className="pull-right" style={convertLineStyleData('color:#333;')}>
                                        {'¥ ' + orderInfo.final_payment_total_price}
                                      </span>
                                    </React.Fragment>
                                  )}
                            </div>
                          )}
                      </div>
                      {presell_status != 10 && presell_status != 12 && (
                        <div className="freight">
                          <span>运费</span>
                          <span className="pull-right">{'¥ ' + express_fee}</span>
                        </div>
                      )}
                    </React.Fragment>
                  ) : (
                      <React.Fragment>
                        <div className="detail-msg">
                          {presell_status == 5 ? (
                            <React.Fragment>
                              <div className="presell-amount">
                                <span>商品定金</span>
                                <span className="pull-right">
                                  {'¥' + orderInfo.total_bargain}
                                </span>
                              </div>
                              <div className="goods-amount">
                                <span>商品尾款</span>
                                <span className="pull-right">
                                  {'¥ ' +
                                    orderInfo.presell_shopping_cart[0]
                                      .final_payment}
                                </span>
                              </div>
                              <div className="freight">
                                <span>运费</span>
                                <span className="pull-right">
                                  {'¥ ' + express_fee}
                                </span>
                              </div>
                              <div className="actual-payment">
                                <span>实际付款</span>
                                <span className="pull-right">
                                  {'¥ ' +
                                    (presell_status == 5
                                      ? '0.00'
                                      : orderInfo.total_price)}
                                </span>
                              </div>
                            </React.Fragment>
                          ) : (
                              <React.Fragment>
                                <div className="refund-amount">
                                  <span>退款金额</span>
                                  <span className="pull-right">
                                    {'¥' + orderInfo.refund_apply.refund_price}
                                  </span>
                                </div>
                                {(presell_status == 7 ||
                                  presell_status == 9 ||
                                  presell_status == 6) && (
                                    <div
                                      className="refund-time"
                                      style={convertLineStyleData('padding-bottom:30rpx;')}
                                    >
                                      <span>退款时间</span>
                                      <span className="pull-right">
                                        {orderInfo.refund_apply.add_time}
                                      </span>
                                    </div>
                                  )}
                              </React.Fragment>
                            )}
                        </div>
                      </React.Fragment>
                    )}
                </div>
                {is_presell_order == 3 && (
                  <div className="total-payment">
                    <span>合计</span>
                    <span className="pull-right">
                      {'¥ ' + orderInfo.actual_amount_of_order}
                    </span>
                  </div>
                )}
              </React.Fragment>
            ) : (
                <React.Fragment>
                  {orderInfo.status == 4 && (
                    <div className="refund-msg">退货信息</div>
                  )}
                  {orderInfo.goods_info && orderInfo.goods_info.map((goods, goodsIndex) => {
                    return (
                      <React.Fragment key={goodsIndex}>
                        <div className="goods-detail-box">
                          <img src={goods.cover} />
                          <div>
                            <div className="goods-name">
                              <span className="is-seckill">预售</span>
                              {goods.goods_name}
                            </div>
                            <div className="goods-rules">
                              {goods.model_value == null ? '' : goods.model_value}
                            </div>
                            <div className="goods-price">
                              {!goods.use_integral || goods.use_integral == 0 ? (
                                <React.Fragment>
                                  <span
                                    className="colorff7"
                                    style={convertLineStyleData('color:' + storeStyle.theme)}
                                  >
                                    {'¥' + goods.price}
                                  </span>
                                </React.Fragment>
                              ) : (
                                  <React.Fragment>
                                    {goods.price != '0.00' && (
                                      <span
                                        className="colorff7"
                                        style={convertLineStyleData('color:' + storeStyle.theme)}
                                      >
                                        {'¥' + goods.price}
                                      </span>
                                    )}
                                    {goods.max_can_use_integral &&
                                      goods.max_can_use_integral != '0' &&
                                      goods.max_can_use_integral != 0 &&
                                      goods.price != '0.00' && (
                                        <span
                                          className="colorff7"
                                          style={convertLineStyleData('color:' + storeStyle.theme)}
                                        >
                                          +
                                    </span>
                                      )}
                                    {goods.max_can_use_integral &&
                                      goods.max_can_use_integral != '0' &&
                                      goods.max_can_use_integral != 0 && (
                                        <span
                                          className="colorff7"
                                          style={convertLineStyleData('color:' + storeStyle.theme)}
                                        >
                                          {goods.max_can_use_integral + '积分'}
                                        </span>
                                      )}
                                  </React.Fragment>
                                )}
                              <span className="pull-right">{'x ' + goods.num}</span>
                            </div>
                          </div>
                        </div>
                      </React.Fragment>
                    )
                  })}
                  <div className="detail-msg">
                    <div className="goods-amount">
                      <span>商品金额</span>
                      <span className="pull-right">
                        {'¥ ' + orderInfo.original_price}
                      </span>
                    </div>
                    {orderInfo.has_seckill == 1 && (
                      <div className="spike-offer">
                        <span>活动优惠</span>
                        <span className="pull-right">
                          {'秒杀  - ¥ ' + orderInfo.seckill_cut_price}
                        </span>
                      </div>
                    )}
                    {orderInfo.selected_benefit_info && (
                      <div className="promotion-method">
                        <div>
                          <span>优惠方式</span>
                          <span className="pull-right promotion-method-title">
                            {orderInfo.selected_benefit_info.title || '无'}
                          </span>
                        </div>
                        <div className="pull-right" style={convertLineStyleData('margin-top:20rpx;')}>
                          {'- ¥ ' + discount_cut_price}
                        </div>
                      </div>
                    )}
                    {/*  <view class="total-order-price">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      <text>订单总价</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      <text class="pull-right">¥ {{ order_total_price }}</text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    </view>  */}
                    {useBalance > 0 && (
                      <div className="stored-value-deduction">
                        <span>储值抵扣</span>
                        <span className="pull-right">{'- ¥ ' + useBalance}</span>
                      </div>
                    )}
                    {orderInfo.coupon_fee && (
                      <div>
                        社交立减金
                      <span className="pull-right">
                          {'- ¥ ' + orderInfo.coupon_fee}
                        </span>
                      </div>
                    )}
                    {hasAdditionalInfo && (
                      <div
                        className="addition-info"
                        onClick={this.seeAdditionalInfo}
                      >
                        <div>
                          <span>补充信息</span>
                          <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="freight">
                    <span>运费</span>
                    <span className="pull-right">{'¥ ' + express_fee}</span>
                  </div>
                  <div className="actual-payment">
                    <span>实际付款</span>
                    <span className="pull-right">
                      {'¥' + orderInfo.total_price}
                    </span>
                  </div>
                </React.Fragment>
              )}
            <div style={convertLineStyleData('margin-top:16rpx;')}>
              {hasAdditionalInfo && (
                <div
                  className="addition-info isRelative"
                  onClick={this.seeAdditionalInfo}
                >
                  <div>
                    <span>补充信息</span>
                    <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
                  </div>
                </div>
              )}
              {orderInfo.remark && (
                <div className="buyer-message">
                  <span>买家留言</span>
                  <span className="pull-right">{orderInfo.remark}</span>
                </div>
              )}
              <div
                className="addition-info no-border isRelative"
                onClick={this.goOrderProgress}
                style={convertLineStyleData('margin-top:0;')}
              >
                <div>
                  <span>订单进度</span>
                  <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
                </div>
              </div>
            </div>
            {hasAlreadyGoods && (
              <div
                className="addition-info no-border already-refund-goods"
                onClick={this.goAlreadyGoodsPage}
              >
                <div>
                  <span>已退商品</span>
                  <span className="pull-right colord2d2 ico-moon icon-rightarrow"></span>
                </div>
              </div>
            )}
            <div className="order-number">
              <div>
                <span>订单编号</span>
                <span>{orderInfo.order_id}</span>
                <span className="pull-right copy-btn" onClick={this.copyOrderId}>
                  复制
                </span>
              </div>
              <div>
                <span>下单时间</span>
                <span>{orderInfo.add_time}</span>
              </div>
              {orderInfo.pick_up_type == 2 && (
                <div>
                  <span>送达时间</span>
                  <span>
                    {
                      orderInfo.ecommerce_info.intra_city_data
                        .intra_city_appointment_arrive_time
                    }
                  </span>
                </div>
              )}
              {orderInfo.pick_up_type == 3 && (
                <React.Fragment>
                  {orderInfo.ecommerce_info.ec_tostore_data
                    .ec_tostore_appointment_time && (
                      <div>
                        <span>预约时间</span>
                        <span>
                          {
                            orderInfo.ecommerce_info.ec_tostore_data
                              .ec_tostore_appointment_time
                          }
                        </span>
                      </div>
                    )}
                  {orderInfo.ecommerce_info.ec_tostore_data
                    .ec_tostore_location_name && (
                      <div>
                        <span>店内位置</span>
                        <span>
                          {
                            orderInfo.ecommerce_info.ec_tostore_data
                              .ec_tostore_location_name
                          }
                        </span>
                      </div>
                    )}
                  {orderInfo.ecommerce_info.ec_tostore_data
                    .ec_tostore_buyer_phone && (
                      <div>
                        <span>手机号码</span>
                        <span>
                          {
                            orderInfo.ecommerce_info.ec_tostore_data
                              .ec_tostore_buyer_phone
                          }
                        </span>
                      </div>
                    )}
                </React.Fragment>
              )}
            </div>
            {presell_status != 2 && presell_status != 10 && presell_status != 12 && (
              <div className="order-bottom">
                {is_presell_order == 1 || is_presell_order == 3 ? (
                  <React.Fragment>
                    {(presell_status == 0 ||
                      presell_status == 1 ||
                      presell_status == 3) && (
                        <React.Fragment>
                          {presell_status != 3 && (
                            <span
                              className="apply-refund isRelative"
                              onClick={this.showEventDialog}
                              data-type="cancelOrder"
                            >
                              取消订单
                            </span>
                          )}
                          <span
                            className="btn btn-orange orderDetail-pay-directly isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.payOrder}
                          >
                            立即支付
                          </span>
                        </React.Fragment>
                      )}
                    {presell_status == 4 && (
                      <React.Fragment>
                        <span
                          className="apply-refund isRelative"
                          onClick={this.applyDrawback}
                        >
                          申请退款
                        </span>
                        <span
                          className="btn btn-orange isRelative"
                          style={convertLineStyleData(
                            'color:' +
                            storeStyle.theme +
                            ';border-color:' +
                            storeStyle.theme
                          )}
                          onClick={this.getWriteOffCodeBox}
                        >
                          核销码
                        </span>
                      </React.Fragment>
                    )}
                    {/*  <block wx:if="{{presell_status == 6}}">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <text wx:if="{{ orderInfo.is_pay_on_delivery != 1 }}" class="btn isRelative" bindtap="editorRefund">修改申请
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <form bindsubmit="formSubmit_collect" report-submit="true" class="getFormId" data-id="{{goods.id}}" data-orderid="{{goods.order_id}}" data-bargainid="{{goods.bargain_id}}">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <button formType="submit" hover-class="none" class='invisibleclass'>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  </button>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </form>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              <text class="btn isRelative" bindtap="cancelRefund">取消退款
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                <form bindsubmit="formSubmit_collect" report-submit="true" class="getFormId" data-id="{{goods.id}}" data-orderid="{{goods.order_id}}" data-bargainid="{{goods.bargain_id}}">
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  <button formType="submit" hover-class="none" class='invisibleclass'>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  </button>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                </form>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              </text>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                            </block>  */}
                    {(presell_status == 5 ||
                      presell_status == 7 ||
                      presell_status == 9) && (
                        <React.Fragment>
                          <span
                            className="isRelative btn"
                            onClick={this.showEventDialog}
                            data-type="orderDelete"
                          >
                            删除订单
                          </span>
                        </React.Fragment>
                      )}
                    {presell_status == 8 && (
                      <React.Fragment>
                        <span
                          className="isRelative btn"
                          onClick={this.remindCustomer}
                          data-type="remindCustomer"
                        >
                          提醒商家
                        </span>
                      </React.Fragment>
                    )}
                    {is_presell_order == 3 && (
                      <React.Fragment>
                        {presell_status != 4 &&
                          presell_status != 9 &&
                          prsell_status != 6 && (
                            <span
                              className="isRelative btn"
                              onClick={this.showGoodsDetail}
                              data-type="remindCustomer"
                              style={convertLineStyleData('border:1px solid #ff7100;color:#ff7100;')}
                            >
                              去查看
                            </span>
                          )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                ) : (
                    <React.Fragment>
                      {orderInfo.status == 0 && (
                        <React.Fragment>
                          <span
                            className="apply-refund isRelative"
                            onClick={this.showEventDialog}
                            data-type="cancelOrder"
                          >
                            取消订单
                          </span>
                          <span
                            className="btn btn-orange orderDetail-pay-directly isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.payOrder}
                          >
                            立即支付
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 1 && (
                        <React.Fragment>
                          <span
                            className="btn btn-orange isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.getWriteOffCodeBox}
                          >
                            核销码
                          </span>
                          {intraCityStatus > 1 &&
                            intraCityStatus != 5 &&
                            intraCityStatus != 1000 && (
                              <span
                                className="btn isRelative"
                                onClick={this.checkLogistics}
                              >
                                配送信息
                              </span>
                            )}
                          {orderInfo.is_pay_on_delivery == 1 ? (
                            <span
                              className="apply-refund isRelative"
                              onClick={this.showEventDialog}
                              data-type="deliveryDrawback"
                            >
                              取消订单
                            </span>
                          ) : (
                              ((orderInfo.is_group_buy_order != 0 &&
                                orderInfo.can_refund_order == 1) ||
                                orderInfo.is_group_buy_order == 0) &&
                              isFullRefund == 1 && (
                                <span
                                  className="apply-refund isRelative"
                                  onClick={this.applyDrawback}
                                >
                                  申请退款
                                </span>
                              )
                            )}
                        </React.Fragment>
                      )}
                      {orderInfo.status == 2 && (
                        <React.Fragment>
                          {orderInfo.pick_up_type != 3 && (
                            <span
                              className="btn isRelative"
                              onClick={this.checkLogistics}
                            >
                              配送信息
                            </span>
                          )}
                          {orderInfo.is_pay_on_delivery == 1 ? (
                            <span
                              className="apply-refund isRelative"
                              onClick={this.showEventDialog}
                              data-type="deliveryDrawback"
                            >
                              取消订单
                            </span>
                          ) : (
                              ((orderInfo.is_group_buy_order != 0 &&
                                orderInfo.can_refund_order == 1) ||
                                orderInfo.is_group_buy_order == 0) &&
                              isFullRefund == 1 && (
                                <span
                                  className="apply-refund isRelative"
                                  onClick={this.applyDrawback}
                                >
                                  申请退款
                                </span>
                              )
                            )}
                          <span
                            className="btn btn-orange isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.getWriteOffCodeBox}
                          >
                            核销码
                          </span>
                          <span
                            className="btn btn-orange isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.showEventDialog}
                            data-type="sureReceipt"
                          >
                            确认收货
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 3 && (
                        <React.Fragment>
                          <span
                            className="apply-refund  isRelative"
                            onClick={this.showEventDialog}
                            data-type="orderDelete"
                          >
                            删除订单
                          </span>
                          <span
                            className="btn btn-orange isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.getWriteOffCodeBox}
                          >
                            核销码
                          </span>
                          <span
                            className="btn btn-orange isRelative"
                            style={convertLineStyleData(
                              'color:' +
                              storeStyle.theme +
                              ';border-color:' +
                              storeStyle.theme
                            )}
                            onClick={this.makeComment}
                          >
                            去评价
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 4 && (
                        <React.Fragment>
                          <span
                            className="btn isRelative"
                            onClick={this.cancelRefund}
                          >
                            {orderInfo.refund_apply.status == 3 ||
                              orderInfo.refund_apply.status == 4
                              ? '撤销退货'
                              : '撤销申请'}
                          </span>
                          {orderInfo.is_pay_on_delivery != 1 && (
                            <span
                              className="btn isRelative"
                              onClick={this.editorRefund}
                            >
                              修改申请
                            </span>
                          )}
                          {orderInfo.refund_apply.status == 3 && (
                            <span
                              className="btn btn-orange isRelative"
                              style={convertLineStyleData(
                                'color:' +
                                storeStyle.theme +
                                ';border-color:' +
                                storeStyle.theme
                              )}
                              onClick={this.returnInfor}
                            >
                              填写退货信息
                            </span>
                          )}
                        </React.Fragment>
                      )}
                      {orderInfo.status == 5 && (
                        <React.Fragment>
                          <span
                            className="btn isRelative"
                            onClick={this.showEventDialog}
                            data-type="receiveDrawback"
                          >
                            收到退款
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 6 && (
                        <React.Fragment>
                          <span
                            className="apply-refund isRelative"
                            onClick={this.showEventDialog}
                            data-type="orderDelete"
                          >
                            删除订单
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 7 && (
                        <React.Fragment>
                          <span
                            className="apply-refund isRelative"
                            onClick={this.showEventDialog}
                            data-type="orderDelete"
                          >
                            删除订单
                          </span>
                        </React.Fragment>
                      )}
                      {orderInfo.status == 8 && (
                        <React.Fragment>
                          <span
                            className="apply-refund isRelative"
                            onClick={this.showEventDialog}
                            data-type="cancelOrder"
                          >
                            取消订单
                          </span>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
              </div>
            )}
          </div>
          {showWriteOffCodeBox && (
            <div
              className="verification-code"
              onClick={this.hideWriteOffCodeBox}
            >
              <div className="verification-code-tips">
                向商家出示二维码或核销码后即可消费
              </div>
              <div className="verification-image-box">
                <img className="verification-code-img" src={codeImgUrl} />
                {codeStatus == 1 && (
                  <div className="verification-code-finished">
                    <div>已核销</div>
                  </div>
                )}
              </div>
              <div className="verification-code-text">
                <span>核销码：</span>
                <span>{codeNum}</span>
              </div>
            </div>
          )}
          {showEventDialog && (
            <div className="event-dialog-mask">
              <div className="event-dialog">
                {eventType == 'cancelOrder' && (
                  <div className="event-dialog-title">确认取消订单？</div>
                )}
                {eventType == 'orderDelete' && (
                  <div className="event-dialog-title">
                    订单删除后不可找回，确认删除？
                  </div>
                )}
                {eventType == 'receiveDrawback' && (
                  <div className="event-dialog-title">确定已收到退款？</div>
                )}
                {eventType == 'sureReceipt' && (
                  <div className="event-dialog-title">确定已收到货物？</div>
                )}
                {eventType == 'deliveryDrawback' && (
                  <div className="event-dialog-title">确认取消订单？</div>
                )}
                <div className="event-dialog-bottom">
                  <span className="event-cancel" onClick={this.hideEventDialog}>
                    取消
                  </span>
                  {eventType == 'cancelOrder' && (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      className="event-sure"
                      onClick={this.cancelOrder}
                    >
                      确认
                    </span>
                  )}
                  {eventType == 'orderDelete' && (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      className="event-sure"
                      onClick={this.orderDelete}
                    >
                      确认
                    </span>
                  )}
                  {eventType == 'receiveDrawback' && (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      className="event-sure"
                      onClick={this.receiveDrawback}
                    >
                      确认
                    </span>
                  )}
                  {eventType == 'sureReceipt' && (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      className="event-sure"
                      onClick={this.sureReceipt}
                    >
                      确认
                    </span>
                  )}
                  {eventType == 'deliveryDrawback' && (
                    <span
                      style={convertLineStyleData('color:' + storeStyle.theme)}
                      className="event-sure"
                      onClick={this.deliveryDrawback}
                    >
                      确认
                    </span>
                  )}
                </div>
              </div>
            </div>
          )}
        </React.Fragment>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/presell-order-detail/PresellOrderDetail.jsx